import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';

const S = {};
const { widthSmall } = breakpoints;

S.LoginForgotPassword = styled.span`
  label: Forgot;

  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
  margin-bottom: 2.2rem;

  @media (${widthSmall}) {
    margin-bottom: 2rem;
  }
`;

export default S;
